<template>
    <header class="header">
        <a class="toggle" @click="toggleMenu">
            <i class="fas fa-bars"></i>
        </a>
        <h1 class="title">
            <img v-if="logoVisible" src="@/assets/images/logo_esig_p.png" alt="Logo">
            <!-- <router-link to="/">{{ title }}</router-link> -->
        </h1>
        <UserDropdown v-show="dropdownXS" v-if="!hideUserDropdown" />
    </header>
</template>

<script>
import UserDropdown from './UserDropdown'

export default {
    name: 'Header',
    components: { UserDropdown },
    props: {
        title: String,
        hideToggle: Boolean,
        hideUserDropdown: Boolean
    },
    computed: {
        logoVisible() {
            return this.$mq === "xs"
        },
        dropdownXS(){
            return this.$mq !== "xs"
        }
    },
    methods: {
        toggleMenu() {
            this.$store.commit('toggleMenu')
        }
    },
    mounted() {
        
    }
}
</script>

<style>
    .header {
        grid-area: header;
        background-color: #343a40;
        color: #efefef;
        border-bottom: 1px solid #dee2e6;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .title {
        font-size: 1.2rem;
        color: #fff;
        font-weight: 100;
        flex-grow: 1;
        text-align: center;
    }

    .title img {
        max-height: 40px;
        margin-top: 8px;
        margin-left: -20px;
        width: auto;
    }

    .title a:hover {
        color: #FFF;
        text-decoration: none;
    }

    header.header > a.toggle {
        width: 60px;
        height: 100%;
        /*color:rgba(0,0,0, 0.5);*/
        justify-self: flex-start;
        text-decoration: none;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    header.header > a.toggle:hover {
        color: #fff;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.3);
    }
</style>
